import { Logger } from "../Logger";
import { GatingStateController } from "gather-client-common/dist/src/public/gatekeeping/GatingStateController";
let gatingStateController;
export const getGatingStateController = () => {
    gatingStateController ||= new GatingStateController(Logger);
    return gatingStateController;
};
//# sourceMappingURL=getGatingStateController.js.map